import { Chip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tbPalette } from 'styles/colors';

interface FilterChipProps extends Omit<ChipProps, 'color'> {
  name: string;
  label: string;
  active?: boolean;
  selected?: boolean;
  lastClicked?: boolean;
}

const StyledChip = styled(Chip, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'selected' && prop !== 'lastClicked',
})<{ active?: boolean; selected?: boolean; lastClicked?: boolean }>(({ active, selected, lastClicked }) => {
  const getBackgroundColor = () => {
    if (active) return tbPalette.data.vis.grid;
    if (selected) return `${tbPalette.background.default}`;
    if (lastClicked) return `${tbPalette.background.default}`; // Hover-like state for last clicked
    return 'none';
  };

  return {
    backgroundColor: getBackgroundColor(),
    border: '1px solid'.concat(tbPalette.interactive.border.default),
    fontWeight: 300,
    fontSize: '12px',
    height: '26px',
    cursor: 'pointer',
    '&:focus': {
      backgroundColor: getBackgroundColor(),
    },
    '& .MuiChip-deleteIcon': {
      color: 'black',
      width: '12px',
      visibility: 'visible',
      display: 'block',
    },
    '& .MuiChip-icon': {
      visibility: active ? 'visible' : 'hidden',
      color: tbPalette.text.primary,
    },
  };
});

function FilterChip({
  name,
  label,
  active = false,
  selected = false,
  lastClicked = false,
  onClick,
  ...otherProps
}: FilterChipProps) {
  return (
    <StyledChip
      title={otherProps.title ?? name}
      label={label}
      icon={otherProps.icon}
      deleteIcon={otherProps.deleteIcon}
      active={active}
      selected={selected}
      lastClicked={lastClicked}
      onClick={onClick}
      onDelete={otherProps.onDelete}
      variant="outlined"
      size={otherProps.size}
      disabled={otherProps.disabled}
      className={otherProps.className}
      style={otherProps.style}
      sx={otherProps.sx}
    />
  );
}

export { FilterChip };
